module.exports = __webpack_public_path__ + "img/default.899f5b9.png";